<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap
  width 100%
  height 180px
  padding 23px 31px
  position relative
  color: #fff
  .swiper-button-next, .swiper-button-prev
    width 16px
    height 30px
    top 86px
  .swiper-button-prev
    background url("../../../../static/img/trace/left.png")
    background-size 100% 100%
  .swiper-button-next
    background url("../../../../static/img/trace/right.png")
    background-size 100% 100%

</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="banner.length!=0">
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <img :src="item.url" alt="" width='122px'/>
          <div style="text-align:center;color:#fff">{{item.name}}</div>
        </swiper-slide>
        <!-- 常见的小圆点 -->
        <!-- <div class="swiper-pagination"  v-for="(item,index) in banner" :key="index" slot="pagination" ></div> -->
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </boxWrap>
</template>

<script>
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import boxWrap from 'components/dashboard/common/boxWrap';
import p1 from '../../../../static/img/trace/p1.png';
import p2 from '../../../../static/img/trace/p2.png';
import p3 from '../../../../static/img/trace/p3.png';
import p4 from '../../../../static/img/trace/lb.png';
import p5 from '../../../../static/img/trace/lb2.png';
import p6 from '../../../../static/img/trace/lb3.png';
export default {
  data() {
    const that = this;
    return {
      name: '品控产品（10个）',
      banner: [
        {
          url: p1,
          name: '白色芒果'
        },
        {
          url: p2,
          name: '牛心李'
        },
        {
          url: p3,
          name: '圣女果'
        },
        {
          url: p4,
          name: '猕猴桃'
        },
        {
          url: p5,
          name: '西林火姜'
        },
        {
          url: p6,
          name: '砂糖桔'
        }
      ],
      swiperOption: {
        slidesPerView: 3,
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 小手掌抓取滑动
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          // 滑动之后回调函数
          slideChangeTransitionStart: function() {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex = this.realIndex - 1;
          }
        }
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?9b6d7e82